import { createFeatureSelector } from '@ngrx/store'

import { ObtienePedidoState } from '../reducers/ecommerce.reducer'

export const selectOrdersState = createFeatureSelector<ObtienePedidoState>('getOrders')
